import script from "./RingingCallIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./RingingCallIcon.vue?vue&type=script&setup=true&lang=ts"

import "./RingingCallIcon.vue?vue&type=style&index=0&id=0b3cdd2c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b3cdd2c"]])

export default __exports__